import dateFormatLib, { i18n as i18nDateformat } from 'dateformat';
import i18n from 'asset/translation';

i18nDateformat.dayNames = [
    i18n.t('common.week.monday'),
    i18n.t('common.week.tuesday'),
    i18n.t('common.week.weednesday'),
    i18n.t('common.week.thursday'),
    i18n.t('common.week.friday'),
    i18n.t('common.week.saturday'),
    i18n.t('common.week.sunday'),
];

i18nDateformat.monthNames = [
    i18n.t('common.shortMonths.JANUARY'),
    i18n.t('common.shortMonths.FEBRUARY'),
    i18n.t('common.shortMonths.MARCH'),
    i18n.t('common.shortMonths.APRIL'),
    i18n.t('common.shortMonths.MAY'),
    i18n.t('common.shortMonths.JUNE'),
    i18n.t('common.shortMonths.JULY'),
    i18n.t('common.shortMonths.AUGUST'),
    i18n.t('common.shortMonths.SEPTEMBER'),
    i18n.t('common.shortMonths.OCTOBER'),
    i18n.t('common.shortMonths.NOVEMBER'),
    i18n.t('common.shortMonths.DECEMBER'),
    i18n.t('common.months.JANUARY'),
    i18n.t('common.months.FEBRUARY'),
    i18n.t('common.months.MARCH'),
    i18n.t('common.months.APRIL'),
    i18n.t('common.months.MAY'),
    i18n.t('common.months.JUNE'),
    i18n.t('common.months.JULY'),
    i18n.t('common.months.AUGUST'),
    i18n.t('common.months.SEPTEMBER'),
    i18n.t('common.months.OCTOBER'),
    i18n.t('common.months.NOVEMBER'),
    i18n.t('common.months.DECEMBER'),
];

export class DateFormatter {
    dateFormat: string;

    dateFormatVerbose: string;

    constructor(dateFormat: string) {
        this.dateFormat = dateFormat;
        this.dateFormatVerbose = this.parseToVerbose(dateFormat);
    }

    parseToVerbose = (dateFormat: string): string =>
        [dateFormat.slice(0, dateFormat.toLowerCase().indexOf('m')), 'm', dateFormat.slice(dateFormat.toLowerCase().indexOf('m'))]
            .join('')
            .toLowerCase();

    d = (date: DateFormatterParams): string => {
        let parsedDate;
        if (typeof date === 'string') {
            parsedDate = new Date(date);
        } else parsedDate = date;
        return dateFormatLib(parsedDate, this.dateFormat.toLowerCase());
    };

    dh = (date: DateFormatterParams): string => {
        let parsedDate;
        if (typeof date === 'string') {
            parsedDate = new Date(date);
        } else parsedDate = date;
        return dateFormatLib(parsedDate, `${this.dateFormat.toLowerCase()} HH:MM`, true);
    };

    dhs = (date: DateFormatterParams): string => {
        let parsedDate;
        if (typeof date === 'string') {
            parsedDate = new Date(date);
        } else parsedDate = date;
        return dateFormatLib(parsedDate, `${this.dateFormat.toLowerCase()} HH:MM:ss`, true);
    };

    dhverbose = (date: DateFormatterParams): string => {
        let parsedDate;
        if (typeof date === 'string') {
            parsedDate = new Date(date);
        } else parsedDate = date;
        return dateFormatLib(parsedDate, `${this.dateFormatVerbose} HH:MM`, true);
    };
}

type DateFormatterParams = string | Date;
